import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class JobErpClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async listar(params = {}) {
    try {
      const cleaned = {};
      Object.entries(params).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== '') cleaned[k] = v;
      });
      return await this.api.get('/jobs-erp', { params: cleaned });
    } catch (err) { this.error.errorShow(err); throw err; }
  }

  async buscarPorId(id) {
    try { return await this.api.get(`/jobs-erp/${id}`); }
    catch (err) { this.error.errorShow(err); throw err; }
  }

  async criar(payload) {
    try { return await this.api.post('/jobs-erp', payload); }
    catch (err) { this.error.errorShow(err); throw err; }
  }

  async atualizar(id, payload) {
    try { return await this.api.put(`/jobs-erp/${id}`, payload); }
    catch (err) { this.error.errorShow(err); throw err; }
  }

  async excluir(id) {
    try { return await this.api.delete(`/jobs-erp/${id}`); }
    catch (err) { this.error.errorShow(err); throw err; }
  }

  async executar(id) {
    try { return await this.api.post(`/jobs-erp/${id}/executar`); }
    catch (err) { this.error.errorShow(err); throw err; }
  }

  async reprocessar(id, execId) {
    try { return await this.api.post(`/jobs-erp/${id}/execucoes/${execId}/reprocessar`); }
    catch (err) { this.error.errorShow(err); throw err; }
  }

  async listarExecucoes(id, params = {}) {
    try {
      const cleaned = {};
      Object.entries(params).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== '') cleaned[k] = v;
      });
      return await this.api.get(`/jobs-erp/${id}/execucoes`, { params: cleaned });
    } catch (err) { this.error.errorShow(err); throw err; }
  }

  async buscarExecucao(id, execId) {
    try { return await this.api.get(`/jobs-erp/${id}/execucoes/${execId}`); }
    catch (err) { this.error.errorShow(err); throw err; }
  }

  async dashboard() {
    try { return await this.api.get('/jobs-erp/dashboard'); }
    catch (err) { this.error.errorShow(err); throw err; }
  }
}
